module.exports = __webpack_public_path__ + "img/pronto.f128ac1f.svg";